import es from "./es";

const locale = new Map([["es", es]]);

export const getTranslations = (lang, value) => locale.get(lang).get(value);

export default locale;
